export default class SliderComponent {
  constructor() {
    var dataAutoplay = document.querySelector('[data-autoplay]');
    var autoplay = false;
    if(dataAutoplay){
      autoplay=true;
    } else {
      autoplay=false;
    }
    console.log(autoplay);
    const swiperThumb = new Swiper('.nav-slider', {
      lazy: false,
      slidesPerView: 4,
      watchSlidesProgress: true,
      allowTouchMove: false,

      breakpoints: {
        320: {
          slidesPerView: 1,
          watchSlidesProgress: false,
          allowTouchMove: true,
        },
        1200: {
          slidesPerView: 4,
          watchSlidesProgress: true,
          allowTouchMove: false,
        },
      },
    })
    const slider = new Swiper('.slider_slider_component', {
      loop: true,
      autoplay: autoplay,
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ['-20%', 0, -1],
        },
        next: {
          translate: ['100%', 0, 0],
        },
      },

      navigation: {
        nextEl: '.slider-button-next',
        prevEl: '.slider-button-prev',
      },

      thumbs: {
        swiper: swiperThumb,
      },
    })

    slider.on('slideChange', function () {
      swiperThumb.slideTo(this.realIndex)
    })

    if (
      document.querySelectorAll('.nav-slider .swiper-wrapper .item-nav')
        .length <= 1
    ) {
      document.querySelector('.nav-slider').style.display = 'none'
    }
  }
}
new SliderComponent();
